import type { FaireAdPerformancePeriodEntity } from "../../entity_types/adPerformancePeriod";

export const perfP3HighBudgetNew202512: FaireAdPerformancePeriodEntity = {
  token: "perf_p3_high_budget_new_202512",
  type: "adPerformancePeriod",
  scope: "NEW_MARKETPLACE",
  periodType: "RECEIPT",
  startDate: "2025-12-01",
  endDate: "2025-12-31",
  impressions: 9869,
  clicks: 159,
  adsSpendDollars: 1038,
  budgetDollars: 1500,
  salesDollars: 17715,
  bestEstimateRoas: 17.07,
  bestEstimateType: "ACTUALIZED",
  budgetUtilization: 0.69,
  newCustomersAcquired: 7,
  dataAvailableAtDate: "2026-01-04",
  meta: {
    source: "mock",
    importedAt: "2026-07-06T00:00:00.000Z",
    importedBy: "advertiser-profiles",
  },
};
